<template>
  <forgerock-template id="reset-password" :title="$t('dss.page.resetPW.title')">

    <bootstrap-alerts :alerts="alerts"/>

    <stihl-section>
      <stihl-overlay :active="state === 'loading'" :spinner="true">

        <form @submit.prevent="save">
          <group-input id="email"
                       type="email"
                       :label="$t('dss.label.email')"
                       group-class="form-group"
                       :required="true"
                       autocomplete="email"
                       autofocus
                       v-model="v$.form.email.$model"
                       :validation-errors="v$.form.email.$errors"/>

          <div class="buttons">
            <button id="save" type="button" class="btn btn-primary" @click="save" :disabled="state==='loading'">
              {{ $t('dss.button.continue') }}
            </button>
            <button id="back" type="button" class="btn btn-default" @click="back">
              {{ $t('dss.button.back') }}
            </button>
            <help-menu/>
          </div>
        </form>

      </stihl-overlay>
    </stihl-section>

  </forgerock-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import StihlSection from '@/components/ui/StihlSection.vue';
import GroupInput from '@/components/ui/GroupInput.vue';
import useVuelidate from '@vuelidate/core';
import { required, validEmail } from '@/components/validators';
import ForgerockTemplate from '@/components/layout/ForgerockTemplate.vue';
import GroupSwitch from '@/components/ui/GroupSwitch.vue';
import HelpMenu from '@/components/ui/HelpMenu.vue';
import { i18n } from '@/lang';
import Backend from '@/components/backend';
import { useUserStore } from '@/components/user.store';
import { Alert } from '@/components/ui/BootstrapAlerts.vue';
import { AxiosError } from 'axios';

export default defineComponent({
  name: 'ResetPasswordPage',
  components: { HelpMenu, GroupSwitch, ForgerockTemplate, StihlSection, GroupInput },
  data() {
    return {
      form: {
        email: '',
      },
      state: 'ready',
      alerts: [] as Alert[],
    };
  },
  methods: {
    alert(message: string, _class?: string) {
      this.alerts.push({ message, class: _class });
    },
    back() {
      window.history.back();
    },
    save() {
      if (this.state === 'loading') {
        console.log('wait. loading');
        return;
      }

      this.alerts.length = 0;

      (this.v$ as any).form.$touch(); // trigger validation
      if (this.v$.$invalid) return console.error('validation failed', this.v$.$errors);

      this.state = 'loading';

      Backend.resetPassword({
        email: this.form.email,
        locale: i18n.global.locale,

      })
          .then(_r => {
            //this.state = 'ready'

            useUserStore().email = this.form.email;

            console.log('[pw-reset]goto OTP page');
            this.$router.push({ name: 'otp' });

          })
          .catch((e: AxiosError) => {
            if (e.response?.status === 429) {
              this.alert(this.$t('dss.error.throttling'));
            } else {
              this.alert(this.$t('dss.error.generic'));
            }
            this.state = 'error';
          });
    }
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      form: {
        // must match the fields in 'this.form'
        email: {
          required, validEmail,
        },
      }
    };
  },
  mounted() {

    const email = this.$route.query.email as string | null;
    if (email) {
      console.info(`auto-reset-password for email ${email}`);
      this.form.email = email;
      this.save();
    }
  }
});
</script>

<style scoped>
</style>
